import Sheet from '@mui/joy/Sheet';

export default function SimpleSheet() {
  return (
    <Sheet variant="outlined" color="neutral" sx={{ p: 4 }}>
      Hello world!
    </Sheet>
  );
}
